import countryList from './countries.json';

export const COUNTRIES: string[] = countryList as string[];
